import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderEPrescriptionsLoadCertificateModalStore } from './folder-e-prescriptions-load-certificate-modal.store';
import { TranslatePipe } from '@ngx-translate/core';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { CardModule } from '@openng/optimus-ui/card';
import {
    EPrescriptionReadinessObject,
} from '@libs/types/src/services/object-type/sukl/e-prescription-readiness.object';
import { LinkButtonComponent } from '../../../../kit/button/link-button.component';
import { Router } from '@angular/router';
import {
    ServiceUploadCertificateComponent,
} from '../../../service/settings/service-upload-certificate/service-upload-certificate.component';
import {
    UserUploadCertificateComponent,
} from '../../../../user-management/user-secrets/user-upload-certificate/user-upload-certificate.component';
import {
    UserUploadSecretComponent,
} from '../../../../user-management/user-secrets/user-upload-secret/user-upload-secret.component';
import { serviceUri } from '../../../../../utils/router.utils';

@Component({
    selector: 'app-folder-e-prescriptions-load-certificate-modal',
    imports: [
        TranslatePipe,
        CardModule,
        LinkButtonComponent,
        ServiceUploadCertificateComponent,
        UserUploadCertificateComponent,
        UserUploadSecretComponent,
    ],
    templateUrl: './folder-e-prescriptions-load-certificate-modal.component.html',
    styleUrl: './folder-e-prescriptions-load-certificate-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FolderEPrescriptionsLoadCertificateModalStore]
})
export class FolderEPrescriptionsLoadCertificateModalComponent extends BaseDialogComponent {
    public readonly store = inject(
        FolderEPrescriptionsLoadCertificateModalStore,
    );
    public readonly router = inject(Router);
    @ViewChild(ServiceUploadCertificateComponent)
    serviceUploadCertificateComponent!: ServiceUploadCertificateComponent;
    @ViewChild(UserUploadCertificateComponent)
    userUploadCertificateComponent!: UserUploadCertificateComponent;
    @ViewChild(UserUploadSecretComponent)
    userUploadSecretComponent!: UserUploadSecretComponent;

    protected readiness: EPrescriptionReadinessObject;

    constructor() {
        super();
        this.readiness = { ...this.dialogConfig.data.readiness };
    }

    override async save() {
        if (!this.readiness.suklCertificate && this.store.folder()?.serviceId) {
            this.readiness.suklCertificate = await this.saveSUKL();
        }
        if (
            !this.readiness.userQualifiedCertificate &&
            this.store.currentUser()
        ) {
            this.readiness.userQualifiedCertificate = await this.saveKval();
        }
        if (!this.readiness.userSuklIdentity && this.store.currentUser()) {
            this.readiness.userSuklIdentity = await this.saveIdentity();
        }
        if (
            this.readiness.suklCertificate &&
            this.readiness.userQualifiedCertificate &&
            this.readiness.userSuklIdentity
        ) {
            contentGlobalSuccess.next('common.created');
            this.dialogRef.close(true);
        }
    }

    protected navigateToPZS() {
        const serviceId = this.store.folder()?.serviceId;
        if (!serviceId) {
            return;
        }
        this.router.navigate([serviceUri(serviceId, 'settings/eprescriptions')]);
        this.dialogRef.close(false);
    }

    protected navigateToUserProfile() {
        this.router.navigate(['/content/profile']);
        this.dialogRef.close(false);
    }

    private async saveSUKL() {
        return this.serviceUploadCertificateComponent.save();
    }

    private async saveKval() {
        return this.userUploadCertificateComponent.save();
    }

    private async saveIdentity() {
        return this.userUploadSecretComponent.save();
    }
}
